import { initialArticleState } from 'mk2/apps/wiki/containers/Article/Article.constants';
import { ArticleState } from 'mk2/apps/wiki/containers/Article/Article.reducers';
import { AppState } from 'mk2/reducers';

export const getWikiArticleState = (state: AppState, categorySlug: string, articleSlug: string): ArticleState =>
    state.containers.wiki.article[`${categorySlug}/${articleSlug}`] || initialArticleState;
